module.exports = __webpack_public_path__ + "static/ibmb-e1555a3c18c9a57c73ff920b7dfb993f.jpg";